//	+-----------------------------------------------+
//	| DfPE router objects                           |
//	+-----------------------------------------------+

/**
 * @file routers.js
 * @desc contains the routers module
 * @author Geoffrey Pursell
 */

/* global workspace */

define('cardboard/router',[
	// libraries
	"jquery", "underscore", "backbone", "cardboard/jQMSetup", "store",

	// app modules
	"cardboard/util"
],
function ($, _, Backbone, jQueryMobileSetup, Store,
		 Util) {

	/**
	 * @exports cardboard/router
	 * @desc Cardboard router module: Returns the router object that maps URLs
	 * to application flow
	 */
	var CardboardRouter;

	console.log("MODULE: cardboard/routers");


	/**
	 * @class CardboardRouter
	 * @classdesc The main application router. As far as I know, this
	 * will be the only one we need for this app. It deals with URL
	 * changes that happen on page load, or back/forward browser
	 * buttons.
	 * @augments Backbone.Router
	 */

	CardboardRouter = Backbone.Router.extend(/** @lends module:cardboard/routers.CardboardRouter.prototype */{

		/** our list of mappings from URL framents to functions */
		routes: {
			"": "mySchool",
			":reportOrPageCode(/)": "reportOrPage",
			":reportCode/*workspaceString(/)": "setupWorkspace"
		},

		/** attach declarative global events */
		attachGlobalEvents: Util.attachGlobalEvents,

		/** declarative events */
		globalEvents: {
			// none at this time. there used to be, though! maybe it's not
			// appropriate for this thing to respond to events.
		},

		/** constructor */
		initialize: function () {
			this.routesHit = 0;
			//keep count of number of routes handled by your application
			Backbone.history.on("route", function () {
				this.routesHit++;
			}, this);
			this.attachGlobalEvents();
		},


		// EVENT HANDLERS

		// none!
		

		// ACTIONS
		
		back: function () {
			window.history.back();
		},

		setURLForReport: function (report) {
			this.navigate("/" + report.get("url"), {trigger: false});
		},



		// routing functions

		/** URL fragment shows the intro */
		intro: function () {
			if (this.maybeLoadStateFromLocalStorage()) { return; }
			workspace.setWorkspacePage({pageID: "intro", pageURL: "/"});
		},
		/** URL fragment sets the report */
		reportOrPage: function (reportOrPageCode) {
			//This can happen with links shared to LinkedIn. url comes in encoded, then Backbone gets confused. 
			if(reportOrPageCode.indexOf("/") >= 0) { //If there is a slash, we've gone wrong!
				var splitUrl = reportOrPageCode.split('/');
				this.setupWorkspace(splitUrl[0], _.rest(splitUrl, 1).join('/'));
				return;
			}

			if (reportOrPageCode === "map") {
				// If we got here, someone has arrived at the app somehow with
				// "/map" on the end of the URL. This should not happen, but if
				// it does, we go right to the intro page and forget about it.
				this.navigate("/", {trigger: true});
			} else {
				workspace.reconstruct(reportOrPageCode);
			}
		},

		/** we've got a URL that wants to set up the whole workspace, let's rock */
		setupWorkspace: function (reportCode, workspaceString) {
			var boxes = workspaceString.split("/");
			// hydrate the workspace string into parameter objects
			boxes = _(boxes)
				.map(function (string) {
					var object = {},
						params = string.split("__");

					_(params).each(function (paramString) {
						var pair = paramString.split("--");
						object[pair[0]] = pair[1];
					});
					return object;
				})
				.value();

			// tell the workspace controller to set everything up
			window.workspace.reconstruct(reportCode, boxes);
		},

		/** this is for working around lossy state management on low-RAM
		 * tablets. We need to call it at the top of the intro hander above,
		 * because that's where we may decide to restore the previous state
		 * instead. */
		maybeLoadStateFromLocalStorage: function () {
			if (window.navigator.standalone && this.routesHit <= 1) {
				var lastURL = Store.get("lastURL");
				if (lastURL) {
					this.navigate(lastURL, {trigger: true, replace: true});
					return true;
				}
			}
			return false;
		}
	});

	return CardboardRouter;
});

